<template>
  <div class="no-plagiarism-container">
    <div class="success-icon-container">
      <eg-icon icon="check" size="large" class="success-icon" color="primary" />
    </div>
    <div class="original-work-container">
      <h3 class="original-work-title heading-s mb-0">
        {{ $t("essays.originalWorkConfirmed") }}
      </h3>
      <p class="original-work-description paragraph-m mb-0">
        {{ $t("essays.passedPlagiarismChecks") }}<br />
        {{ $t("essays.noSignificantSimilarities") }}<br />
        or external sources.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WithoutPlagiarism",
};
</script>

<style lang="scss" scoped>
.no-plagiarism-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 44px 0;
  border-radius: var(--radius-rd-400, 12px);
  border: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
  background: var(--color-surface-semantic-success-light, #f0faf3);
  text-align: center;

  .success-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: var(--radius-rd-1000, 100px);
    background: var(--color-surface-semantic-success-default, #28a745);
    padding: 8px;
  }

  .original-work-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .original-work-title {
    max-width: 501px;
  }

  .original-work-description {
    max-width: 501px;
  }
}
</style>
